import React from 'react';
import { ResponsiveLine  } from '@nivo/line' 

export default function LineGraph({data}) {
    const parseNumber = (value) => {
        if (value == null || value === "") return 0;
        if (typeof value === "number" && Number.isFinite(value)) return value;
        const str = String(value).trim();
        if (str.includes(",")) {
            return Number(str.replace(/\./g, "").replace(",", "."));
        }
        return Number(str);
    };

    const formatCompact = (num) => {
        if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "Bi";
        if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "Mi";
        if (num >= 1_000) return (num / 1_000).toFixed(0) + "Mil";
        return num;
    };

    const formatPtBR = (num) =>
        new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        }).format(num);

    const safeData = Array.isArray(data) ? data : [];
    const formattedData = safeData.map((series, i) => ({
        id: series.id ?? `serie-${i}`,
        data: Array.isArray(series.data)
        ? series.data.map((p) => ({
            x: p.x ?? "",
            y: parseNumber(p.y),
            }))
        : [],
    }));

    if (formattedData.length === 0) {
        return <div>Sem dados para exibir</div>;
    }

    return (
        <ResponsiveLine
            data={formattedData}
            margin={{ top: 20, right: 110, bottom: 50, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear', min: 'auto', max: 'auto'}}
            axisTop={null}
            axisRight={null}
            colors= {['rgb(57, 115, 156)','#6bb577','#b56b6b','#876bb5']}
            axisBottom={{
                orient: 'bottom',
                tickSize: 5,
                tickPadding: 5,
                tickRotation: -30,
                legend: ' ',
                legendOffset: 36,
                legendPosition: 'middle'
            }}
            axisLeft={{
                orient: 'left',
                tickSize: 5,
                tickPadding: 10,
                tickRotation: 0,
                legend: '',
                legendOffset: -40,
                legendPosition: 'middle',
                format: (v) => formatCompact(v),
            }}
            pointSize={10}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabel="y"
            pointLabelYOffset={-12}
            useMesh={true}
            tooltip={({ point }) => (
            <div
            style={{
                background: "white",
                padding: "6px 9px",
                border: "1px solid #ccc",
                borderRadius: 4,
            }}
            >
            <strong>{point.serieId}</strong>
            <br />
            {point.data.x}: {formatPtBR(point.data.y)}
            </div>
            )}
            legends={[
                {
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 100,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 80,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
        />
    )
};